export interface NotificationPreviewProps {
  title: string;
  body: string;
}

export const NotificationPreview = ({
  title,
  body,
}: NotificationPreviewProps) => {
  return (
    <div className="flex items-end gap-2.5 p-5">
      <img
        className="w-8 h-8 rounded-full"
        src="/images/notification.png"
        alt="Notification"
      />
      <div className="flex flex-col w-full max-w-[320px] leading-1.5 p-4 border-gray-200 bg-gray-100 rounded-tl-lg rounded-tr-lg rounded-br-lg dark:bg-gray-700">
        <div className="flex items-center space-x-2 rtl:space-x-reverse">
          <span className="text-sm font-semibold text-gray-900 dark:text-white">
            {title}
          </span>
        </div>
        <p className="text-sm font-normal py-2.5 text-gray-900 dark:text-white">
          {body}
        </p>
      </div>
    </div>
  );
};
